import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { performLogout } from "@/lib/auth/logout";

export default function UnauthorizedPage() {
  const navigate = useNavigate();

  const handleLogout = async () => {
    await performLogout();
    toast.success("로그아웃되었습니다");
    navigate("/login");
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50">
      <div className="w-full max-w-md space-y-6 rounded-lg bg-white p-8 text-center shadow-lg">
        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-red-100">
          <svg
            className="h-8 w-8 text-red-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
            />
          </svg>
        </div>

        <div>
          <h1 className="text-2xl font-bold text-gray-900">접근 권한 없음</h1>
          <p className="mt-2 text-sm text-gray-600">
            관리자 대시보드에 접근할 권한이 없습니다.
          </p>
          <p className="mt-1 text-sm text-gray-500">
            오류라고 생각되시면 관리자에게 문의해주세요.
          </p>
        </div>

        <div className="space-y-3">
          <Button onClick={handleLogout} className="w-full" variant="outline">
            로그아웃
          </Button>
        </div>
      </div>
    </div>
  );
}
